import instance from '@/api/instance';

export default {
    // SETTERS - These are still needed for cross-component communication
    setLoadingState({commit}, isLoading) {
        commit('setLoadingState', isLoading);
    },
    setTaggingMode({commit}, isTagging) {
        commit('setTaggingMode', isTagging);
    },
    setInitialState({commit}, {caseId, messageId}) {
        commit('resetState');
        commit('setCaseId', Number.parseInt(caseId));
        commit('setTaggingMode', true);
        commit('setTaggingMessageId', messageId);
    },
    setCountReminders({commit}, countReminders) {
        commit('setCountReminders', countReminders);
    },
    setCurrentRoute({commit}, currentRoute) {
        commit('setCurrentRoute', currentRoute);
    },
    setKeySearch({commit}, keySearch) {
        commit('resetTabState');
        commit('setKeySearch', keySearch);
    },
    setChatTags({commit}, chatTags) {
        commit('setChatTags', chatTags);
    },
    setEditingComment({commit}, comment) {
        commit('setEditingComment', comment);
    },
    setChatData({commit}, chatData) {
        commit('setChatData', chatData);
    },
    setChatId({commit}, chatId) {
        commit('setChatId', chatId);
    },
    setMessages({commit}, messages) {
        commit('setMessages', messages);
    },
    setReminder({commit}, remindAt) {
        commit('setReminder', remindAt);
    },
    setCaseId({commit}, caseId) {
        commit('setCaseId', Number.parseInt(caseId));
    },
    setSearchMessageId({commit}, messageId) {
        commit('setSearchMessageId', messageId);
    },
    clearSearchMessageId({commit}) {
        commit('clearSearchMessageId');
    },
    setTaggingMessageId({commit}, messageId) {
        commit('setTaggingMessageId', messageId);
    },

    // UTILS - These are still needed for cross-component communication
    clearUnBlurredMessage({commit}) {
        commit('setUnBlurredMessage', null);
    },
    resetTabState({commit}) {
        commit('resetTabState');
    },

    // The following actions are still needed for components that haven't been updated to use the mixin
    // getMessageById({state, commit, dispatch}, messageId) {
    //     // This is a stub that delegates to the mixin method
    //     // Components should be updated to use the mixin instead
    //     console.warn('Using deprecated Vuex action: getMessageById. Use mixin method instead.');
    //
    //     let msgId = messageId;
    //     if (!msgId) {
    //         msgId = state.taggingMessage.id;
    //     }
    //     instance.get(`/messages/${state.chatData.caseId}/message/${msgId}/chat/${state.chatData.chatId}`)
    //         .then(res => {
    //             try {
    //                 dispatch('setLoadingState', true);
    //                 commit('setTaggingMessage', res.data.body);
    //                 setTimeout(() => {
    //                     dispatch('getMessageListTags');
    //                 }, 500);
    //                 setTimeout(() => {
    //                     dispatch('getCommentsByMessageId');
    //                 }, 500);
    //                 if (state.currentRoute !== 'comments') {
    //                     const updatedMessages = state.messages.map(message => {
    //                         if (message.id === res.data.body.id) {
    //                             return res.data.body;
    //                         }
    //                         return message;
    //                     });
    //                     commit('setMessages', updatedMessages);
    //                 }
    //             } finally {
    //                 setTimeout(() => commit('setLoadingState', false), 1000);
    //             }
    //         });
    // },

    countActiveRemindersByChatId({state, dispatch}) {
        // This is still used by MessagesTaggingNavigationPanel.vue
        // Keep this implementation until that component is updated to use the mixin
        instance.get(`/reminder/case/${state.chatData.caseId}/chat/${state.chatData.chatId}/count`)
            .then((res) => {
                dispatch('setCountReminders', res.data.body.count);
            });
    },

    // These methods are needed for getMessageById to work
    // getMessageListTags({state, commit}) {
    //     instance.get(`/messages/${state.chatData.caseId}/message/${state.taggingMessage.id}/tags`)
    //         .then(res => {
    //             const messageTags = (res.data.body.categories || []).map(category => ({
    //                 ...category,
    //                 tags: (category.tags || []).map(tag => ({
    //                     ...tag,
    //                     isActive: tag.isSelected,
    //                 })),
    //             }));
    //             commit('setMessageTags', messageTags);
    //         });
    // },

    getCommentsByMessageId({state, commit}) {
        instance.get(`/messages/${state.chatData.caseId}/message/${state.taggingMessage.id}/comments`)
            .then(res => {
                commit('setComments', res.data.body);
            });
    }
};
